import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import LineChart from '../../components/LineChart/LineChart';
import Loading from '../../components/loading/index';
import { useHomeData } from '../../features/home/useHomeData';
import useHomeLoadScripts from '../../hook/scripts/useHomeLoadScripts';
import Amount from "./amount";
import DevicesInfo from "./devicesInfo";
import './style.css';
import Table from "./table";
const Index = () => {
    const { homeData = [], isLoading, isError, getObject } = useHomeData();
    const { t } = useTranslation();
    useHomeLoadScripts()
    if (isLoading) {
        return <Loading isLoading={isLoading} />;
    }
    if (isError) {
        return <Loading isLoading={false} isError={isError} />;
    }
    return (
        <HelmetProvider>

            <div className="page-wrapper">
                <div className="page-content">
                    <div className="row row-cols-1 row-cols-md-2 row-cols-xl-3">
                        <Amount color={'bg-danger-custom'} refundAmount={homeData?.toDaysRefund} refundText={t("home.toDaysRefound")} amount={homeData?.toDaysAmount} text={t("home.todaySuccessfulOrdersAmount")} />
                        <Amount color={'bg-primary-custom'} refundAmount={homeData?.weeklyRefund} refundText={t("home.weeklyRefound")} amount={homeData?.weeklyAmount} text={t("home.SuccessfulOrdersAmountWeek")} />
                        <Amount color={'bg-warning-custom'} refundAmount={homeData?.monthlyRefund} refundText={t("home.monthlyRefound")} amount={homeData?.monthlyAmount} text={t("home.SuccessfulOrdersAmountMonth")} />
                    </div>
                    <div className="row row-cols-1 row-cols-lg-3 row-cols-xl-3">
                        <DevicesInfo total={homeData.all_devices} text={t("home.allDevices")} />
                        <DevicesInfo total={homeData.active_device} text={t("home.activateDevice")} />
                        <DevicesInfo total={homeData.passive_devices} text={t("home.activateOffline")} />
                    </div>
                    <div className="row row-cols-1 row-cols-lg-2 row-cols-xl-2">
                        {/* <div className="col">
                            <ApexChart1 total={statistics['total_rentals']} />
                        </div> */}
                        <div className="col">
                            <LineChart />
                        </div>
                        <div className="col">
                            {/* <PieChart /> */}
                            <Table data={homeData.payments} getObject={getObject} />
                        </div>
                        {/* <div className="col">
                            <PieChart />
                        </div> */}
                    </div>

                </div>
            </div>
        </HelmetProvider>
    )
}

export default Index